import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-integration-details',
  templateUrl: './integration-details.component.html',
  styleUrls: ['./integration-details.component.scss']
})
export class selectedIntegrationDetails$Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
